import { useState, useEffect } from 'react';

import Cookies from 'js-cookie';

import wwwapi from '@/asyncApi/home';
import { buriedPoint } from '@/utils/buriedPoint';
import Domains from '@/utils/domains';
import sendAxios from '@/utils/request';

const IndexTopBanner = ({ setFaterBannerResult, logined, isNeedTopAd }) => {
  const [topBanner, setTopBanner] = useState([]);
  const [bannerResult, setBannerResult] = useState(null);
  const [topBannerShow, setTopBannerShow] = useState(false);
  const [topBannerIdx, setTopBannerIdx] = useState(-1);

  async function fecthData() {
    const { result } = await sendAxios({
      method: 'get',
      url: wwwapi.indexTopBanner,
      baseURL: Domains.lcscOpUrl,
    });
    setBannerResult(result);
    setTopBannerIdx(-1);
    if (result?.some((tb) => tb.backgroundLeftUrl)) {
      setFaterBannerResult && setFaterBannerResult(true);
      setTopBannerIdx(0);
    }
  }

  useEffect(() => {
    setTopBannerShow(!Cookies.get('AdvertisingNotShow'));
    try {
      fecthData();
    } catch (error) {
      console.error(error);
    }
  }, [logined]);

  useEffect(() => {
    if (bannerResult?.length > 0) {
      let timeoutId;
      if (bannerResult.some((tb) => tb.backgroundLeftUrl)) {
        setTopBanner([bannerResult.find((tb) => tb.backgroundLeftUrl)]);
        if (location?.pathname === '/index' || location?.pathname === '/') {
          setTopBannerShow(true);
        }
      } else {
        setTopBanner(bannerResult);
        const updateBannerIdx = () => {
          setTopBannerIdx((prevIdx) => (prevIdx + 1) % bannerResult.length); // 假设共有 5 个 banner
          timeoutId = setTimeout(updateBannerIdx, 5000); // 每隔 5 秒更新一次
        };
        updateBannerIdx(); // 立即执行一次
      }

      return () => {
        clearTimeout(timeoutId); // 清除定时器，避免内存泄漏
      };
    }
  }, [bannerResult]);

  function topBannerBuriedPoint(ck = 'close') {
    buriedPoint({
      cp: 'top_header',
      ty: 'click',
      op: 'top_banner',
      data: {
        hf: topBanner[topBannerIdx].targetLink,
        ck,
      },
    });
  }

  function closeTopBanner() {
    topBannerBuriedPoint();
    Cookies.set('AdvertisingNotShow', true, {
      domain: '.szlcsc.com',
    });
    setTopBannerShow(false);
  }

  function handleClickTopBanner() {
    topBannerBuriedPoint('open');
  }
  if (!topBannerShow || !bannerResult) {
    return <></>;
  }
  let currentTb;
  if (topBanner.length) {
    currentTb = topBanner[topBannerIdx];
  }
  return (
    <section
      className={`${topBanner.length ? 'h-[60px]' : 'h-0'} transition-all duration-500 max-w-[3840px] relative text-center m-auto ${currentTb?.backgroundLeftUrl ? '' : 'contain-layout contain-style contain-paint'}`}
      data-spm="tb"
      aria-label="立创商城-营销图片专区"
    >
      <a
        className={`flex items-center justify-center w-full h-[60px] overflow-hidden mx-auto bg-no-repeat bg-center bg-cover transition-backgroundImage duration-500`}
        style={{
          backgroundImage: currentTb?.advertisingUrl && `url(${currentTb?.advertisingUrl})`,
        }}
        href={currentTb?.targetLink}
        title={currentTb?.title}
        target="_blank"
        onClick={handleClickTopBanner}
        data-spm={topBannerIdx + 1}
        key={topBannerIdx}
      >
        {/* <div
          className={`w-full h-full mx-auto bg-no-repeat bg-center bg-cover transition-backgroundImage duration-500`}
          style={{
            backgroundImage: `url(${currentTb?.advertisingUrl})`,
          }}
        ></div> */}
      </a>
      {currentTb?.backgroundLeftUrl && !isNeedTopAd && (
        <div
          className="absolute top-[60px] left-0 w-full overflow-hidden"
          style={{ background: `url(${currentTb?.backgroundLeftUrl}) center center no-repeat` }}
        >
          <img src={currentTb?.backgroundLeftUrl} alt="横幅背景图" className="invisible" />
        </div>
      )}
      {(!currentTb?.backgroundLeftUrl || isNeedTopAd) && (
        <button
          className="absolute size-[18px] top-[10px] right-[50px] bg-[url(https://static.szlcsc.com/ecp/assets/web/layout/head/images/close_top.png)] p-[4px] hover:opacity-50 z-[6]"
          onClick={closeTopBanner}
        ></button>
      )}
    </section>
  );
};

export default IndexTopBanner;
